module.exports = __webpack_public_path__ + "7af6bb4ea671d825775c7e74b4db8e19.pdf";